import { render } from "./GalleryModal.vue?vue&type=template&id=fe52fd1c&ts=true"
import script from "./GalleryModal.vue?vue&type=script&lang=ts"
export * from "./GalleryModal.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__